import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
var MarkOnHold = /*#__PURE__*/function (_Component) {
  function MarkOnHold(props) {
    var _this;
    _classCallCheck(this, MarkOnHold);
    _this = _callSuper(this, MarkOnHold, [props]);
    _this.state = {
      reason: null
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(MarkOnHold, _Component);
  return _createClass(MarkOnHold, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props = this.props,
        formUrl = _this$props.formUrl,
        csrfToken = _this$props.csrfToken;
      var data = this.state;
      return putRequest(formUrl, data, csrfToken).then(function () {
        window.location.reload();
      })["catch"](function (err) {
        _this2.setState({
          errors: err
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        submitButtonText = _this$props2.submitButtonText,
        triggerType = _this$props2.triggerType,
        triggerText = _this$props2.triggerText,
        triggerStyle = _this$props2.triggerStyle,
        style = _this$props2.style;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        buttonStyles: "danger ".concat(style, " ").concat(triggerStyle),
        submitButtonText: submitButtonText,
        headerTitle: "Are you sure you want to put this project on hold?",
        handleSubmit: this.handleSubmit,
        triggerType: triggerType,
        idKey: "mark-on-hold",
        cloneContent: false
      }, /*#__PURE__*/React.createElement("p", null, "Reason:"), /*#__PURE__*/React.createElement("textarea", {
        value: this.state.reason || '',
        className: "form-control",
        placeholder: "Waiting on funding...",
        name: "reason",
        id: "reason",
        rows: "4",
        onChange: this.handleInputChange
      }));
    }
  }]);
}(Component);
MarkOnHold.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  triggerType: PropTypes.string,
  triggerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  triggerStyle: PropTypes.string,
  style: PropTypes.string
};
MarkOnHold.defaultProps = {
  submitButtonText: 'Yes, submit',
  triggerType: 'button',
  triggerText: 'Put On Hold',
  triggerStyle: '',
  style: ''
};
export default MarkOnHold;